import { useEffect, useState } from "react"
// https://github.com/codegeous/react-component-depot/blob/master/src/pages/HooksDemo/index.js
const useGeoLocation = () => {
  const [location, setLocation] = useState({
    loaded: false,
    lat: null,
    lng: null,
    error: {
      code: "",
      message: "",
    },
  })

  const onSuccess = (location) => {
    setLocation({
      loaded: true,
      lat: location.coords.latitude as number,
      lng: location.coords.longitude as number,
      error: {
        code: "",
        message: "",
      },
    })
  }

  const onError = (error) => {
    setLocation({
      loaded: true,
      lat: null,
      lng: null,

      error: {
        code: error.code,
        message: error.message,
      },
    })
  }

  useEffect(() => {
    if (!("geolocation" in navigator)) {
      onError({
        code: 0,
        message: "Geolocation not supported",
      })
    }

    navigator.geolocation.getCurrentPosition(onSuccess, onError)
  }, [])

  return location
}

export default useGeoLocation
